import {messages} from '@smartmixin/i18n';
import {useIntl} from 'react-intl';
import {WeatherStationFromList} from '../api/types';
import {Station} from '../utils';

/**
 * Accessible name of the eye button that hides or shows a linked station on
 * the station-management screens of both apps: "Hide {station}" while
 * visible, "Unhide {station}" while hidden.
 */
const useStationVisibilityToggleLabel = (
  station: WeatherStationFromList,
  hidden: boolean,
) => {
  const {formatMessage} = useIntl();
  return formatMessage(
    hidden
      ? messages.stations.unhideStationNamed
      : messages.stations.hideStationNamed,
    {station: Station.getStationName(station)},
  );
};

export default useStationVisibilityToggleLabel;
